import GenericExportButton from "components/GenericExportButton";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import {
  CompletionsFilter,
  ExportCertificatesRequest,
  ListRequestOfCompletionsFilter,
} from "services/organizationPortalClient";
import contextStore from "stores/contextStore";

type ExportCertificatesProps = {
  sortField: string;
  sortDescending: boolean;
  filter: CompletionsFilter;
};

const ExportCertificates = ({
  sortField,
  sortDescending,
  filter,
}: ExportCertificatesProps) => {
  const { formatMessage: t } = useIntl();
  const { organization } = contextStore.useState();
  const { certificatesService } = useGlobalContext();

  const exportCertificates = async (): Promise<void> => {
    const getExportedCertificatesResponse =
      await certificatesService.getExportedCertificates(
        ExportCertificatesRequest.fromJS({
          completionsRequest: ListRequestOfCompletionsFilter.fromJS({
            pageSize: -1,
            sortField: sortField,
            sortDescending: sortDescending,
            parameters: filter,
          }),
          fileName: `${organization?.name} certificates.pdf`,
        })
      );

    if (getExportedCertificatesResponse.data?.downloadUrl) {
      window.open(getExportedCertificatesResponse.data.downloadUrl, "_blank");
    } else {
      return Promise.reject(
        new Error(
          getExportedCertificatesResponse.responseReason ??
            t({ id: "unexpectedExportError" })
        )
      );
    }
  };
  return (
    <GenericExportButton
      exportData={exportCertificates}
      exportButtonLabel={t({ id: "certificates" })}
      tooltipLabel={t({ id: "exportCertificates" })}
    />
  );
};

export default ExportCertificates;
